import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { toResponseError, type WebhookRedriveInput, type WebhookRedriveSuccess } from '@terros/common'

export function useRedriveWebhook(): AddHookResponse<WebhookRedriveInput, WebhookRedriveSuccess> {
  const mutation = useTantalimMutation<WebhookRedriveInput, WebhookRedriveSuccess>({
    url: '/webhook/redrive',
  })

  async function redrive(input: WebhookRedriveInput = {}): Promise<WebhookRedriveSuccess> {
    try {
      return await mutation.mutateAsync({ ...input })
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, redrive)
}
